import T, { t } from '../../../../../common/components/T';
import parse from 'html-react-parser';

export const getProductProperties = (product, setProperties, translation) => {
    if (product?.type === 'set') {
        const left_properties = product?.set_products;
        const right_properties = ['gtshop::quantity_included', 'gtshop::country'];
        setProperties({
            left: left_properties,
            right: product?.properties
                ?.filter((property) => right_properties.includes(property.name))
                ?.sort((a, b) => right_properties.indexOf(a.name) - right_properties.indexOf(b.name))
                ?.map((prop) => ({
                    ...prop,
                    value: prop.name === 'gtshop::quantity_included' ? parse(prop.value?.[0] || '') : prop.value
                }))
        });
    } else {
        const left_properties = ['gtshop::peculiarities', 'gtshop::consist', 'gtshop::use'];
        const right_properties = [
            'gtshop::volume_ml',
            'gtshop::volume_weight',
            'gtshop::quantity_included',
            'gtshop::country',
            'gtshop::expiration'
        ];

        const newProperties = {
            left: [],
            right: []
        };

        product?.properties?.forEach((property) => {
            if (left_properties.includes(property.name)) {
                newProperties.left.push({
                    ...property,
                    sort: left_properties.indexOf(property.name) + 1
                });
            } else if (right_properties.includes(property.name)) {
                newProperties.right.push({
                    ...property,
                    sort: right_properties.indexOf(property.name) + 1,
                    title:
                        property.name === 'gtshop::volume_weight' ? (
                            <T textName='product-weight' defaultStr='Обьем продукта' />
                        ) : (
                            property.title
                        ),
                    value:
                        property.name === 'gtshop::volume_weight'
                            ? `${property?.type === 'float' ? parseFloat(property?.value) : property.value} ${t(
                                  'kg',
                                  'кг',
                                  'all',
                                  translation
                              )}`
                            : property?.type === 'float'
                            ? parseFloat(property?.value)
                            : property?.name === 'gtshop::quantity_included'
                            ? parse(property.value?.[0] || '')
                            : property.value,
                    type: null
                });
            }
        });

        newProperties.right.sort((a, b) => a.sort - b.sort);
        newProperties.left.sort((a, b) => a.sort - b.sort);

        if (product?.['cipu']) {
            newProperties.right.push({
                title: <T textName='cipu' defaultStr='ИКПУ' page='/store' />,
                value: product?.['cipu']
            });
        }
        if (product?.['sgr']) {
            newProperties.right.push({
                title: <T textName='sgr' defaultStr='СГР' page='/store' />,
                value: product?.['sgr']
            });
        }

        setProperties(newProperties);
    }
};
